import React from "react";
import { Paper, Stack } from "@mui/material";
import styled from "styled-components";
import { useTeam } from "src/scenes/teams/team/team-provider";
import { Helmet } from "react-helmet";
import MissionsHistoryTeamsTable from "src/scenes/teams/team/missions-history/missions-history-table";
import request from "src/utils/request";
import { useAuth } from "src/components/providers/auth-context";
import { useLocation } from "react-router-dom";
import ShowWithSkeleton from "src/utils/show-with-skeleton";

const MetricCard = styled(Paper)`
    height: 86px;
    width: 100px;
    border-radius: 0;
`;
const MetricTitle = styled.h1`
    font-size: 12px;
    font-weight: 300;
`;
const MetricNumber = styled.h1`
    font-size: 24px;
    font-weight: 500;
    margin: 0;
`;

const MissionsHistoryTeams = () => {
    const teamApi = useTeam();
    const location = useLocation();
    const teamId = location.pathname.split("/")[2];
    const { isDemo, userHasTeamsSubscription } = useAuth();
    const [missions, setMissions] = React.useState("");
    const [missionsStats, setMissionStats] = React.useState("");

    const getMissionsHistoryTeams = async () => {
        let response;
        if (isDemo || !userHasTeamsSubscription) {
            response = (
                await import("src/scenes/teams/team/missions-history/missions-history-mock-data")
            ).default;
        } else {
            response = await request(`/api/missions/team/${teamId}/history`, { method: "GET" });
        }
        setMissions(response.missions);
        setMissionStats(response.missionStats);
    };
    React.useEffect(() => {
        getMissionsHistoryTeams();
    }, []);

    return (
        <>
            <Helmet>
                {teamApi.data && teamApi.data.name && (
                    <title>Adadot - Missions History - {teamApi.data && teamApi.data.name}</title>
                )}
            </Helmet>
            <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                style={{ width: "100%" }}
            >
                <Stack direction="row" p={1}>
                    <p style={{ paddingRight: "12px", fontWeight: "600" }}>
                        {teamApi.data && teamApi.data.name}
                    </p>
                    <p style={{ fontWeight: "200" }}>Missions History</p>
                </Stack>
                <Stack direction="row" spacing={1}>
                    <MetricCard style={{ borderRadius: "8px 0px 0px 8px" }}>
                        <Stack direction="column" justifyContent="center" alignItems="center">
                            <MetricTitle>All</MetricTitle>
                            <ShowWithSkeleton fetchAction={teamApi} height="100%" width="70%">
                                <MetricNumber>{missionsStats && missionsStats.total}</MetricNumber>
                            </ShowWithSkeleton>
                        </Stack>
                    </MetricCard>
                    <MetricCard>
                        <Stack direction="column" justifyContent="center" alignItems="center">
                            <MetricTitle>Active</MetricTitle>
                            <ShowWithSkeleton fetchAction={teamApi} height="100%" width="70%">
                                <MetricNumber>
                                    {missionsStats && missionsStats["in-progress"]}
                                </MetricNumber>
                            </ShowWithSkeleton>
                        </Stack>
                    </MetricCard>
                    <MetricCard>
                        <Stack direction="column" justifyContent="center" alignItems="center">
                            <MetricTitle>Completed</MetricTitle>
                            <ShowWithSkeleton fetchAction={teamApi} height="100%" width="70%">
                                <MetricNumber>
                                    {missionsStats && missionsStats.completed}
                                </MetricNumber>
                            </ShowWithSkeleton>
                        </Stack>
                    </MetricCard>
                    <MetricCard style={{ borderRadius: "0px 8px 8px 0px" }}>
                        <Stack direction="column" justifyContent="center" alignItems="center">
                            <MetricTitle>Failed</MetricTitle>
                            <ShowWithSkeleton fetchAction={teamApi} height="100%" width="70%">
                                <MetricNumber>{missionsStats && missionsStats.failed}</MetricNumber>
                            </ShowWithSkeleton>
                        </Stack>
                    </MetricCard>
                </Stack>
            </Stack>
            {missions.length > 0 && <MissionsHistoryTeamsTable missions={missions} />}
        </>
    );
};

export default MissionsHistoryTeams;
